import BladePic from "../assets/images/Blade.PNG";
import RoboPic from "../assets/images/Robo.PNG";
import PokemonPic from "../assets/images/Pokemin.PNG"
import Magiction from "../assets/images/Magiciangirl.PNG";
import FuryPic from "../assets/images/fury.jpg";
import Remfi from "../assets/images/Remfigure.PNG";
import Conanfi from "../assets/images/Conanfigure.PNG";
import ShoreFigure from "../assets/images/ShoreDetail.PNG";
import Midoriya from "../assets/images/oneforall.PNG";
import Kurumifi from "../assets/images/Kurumifigure.PNG";


// import FuryPic from "../assets/images/fury.jpg";


const ListProduct =[
    {
      index: 1,
      name:  "Robo Figure",
      path: RoboPic,
      NewPrice: "2.057.000 VND",
      brand: "Kotobukiya",
      description: "Kotobukiya Japan 1/72 Armored Core Line Arc White Grint Plastic Model 160Mm" ,
      rating: "12",
    },
    {
      index: 2,
      name:  "Blade Figure",
      path: BladePic,
      NewPrice: "8.046.000 VND",
      brand: "Kotobukiya",
      description: "Kotobukiya Japan 1/72 Armored Core Line Arc White Grint Plastic Model 160Mm" ,
      rating: "32",
    },
    {
      index: 3,
      name:  "Magiction Figure",
      path: Magiction,
      brand: "Kotobukiya",
      NewPrice: "3.756.000 VND",
      description: "Kotobukiya Japan 1/72 Armored Core Line Arc White Grint Plastic Model 160Mm" ,
      rating: "28",
    },
    {
      index: 4,
      name:  "Pokemon Figure",
      path: PokemonPic,
      brand: "Kotobukiya",
      NewPrice: "5.719.000 VND",
      description: "Kotobukiya Japan 1/72 Armored Core Line Arc White Grint Plastic Model 160Mm" ,
      rating: "35",
    },
    {
      index: 5,
      name:  "Raphtalia  Figure",
      path: FuryPic,
      brand: "Kotobukiya",
      NewPrice: "4.237.000 VND",
      description: "Kotobukiya Japan 1/72 Armored Core Line Arc White Grint Plastic Model 160Mm" ,
      rating: "76",
    },
    {
      index: 6,
      name:  "Rem Figure",
      path: Remfi,
      brand: "Kotobukiya",
      NewPrice: "1.979.000 VND",
      description: "SH Figuarts My Hero Academia Midoriya & Katsuki Bakugo Set" ,
      rating: "76",
    },
    {
      index: 7,
      name:  "Conan Figure",
      path: Conanfi,
      brand: "GENDA GIGO Entertainment",
      NewPrice: "3.569.000 VND",
      description: "Kotobukiya Japan 1/72 Armored Core Line Arc White Grint Plastic Model 160Mm" ,
      rating: "76",
    },
    {
      index: 8,
      name:  "Shore  Figure",
      path: ShoreFigure,
      brand: "Kotobukiya",
      NewPrice: "2.953.000 VND",
      description: "Shorekeeper 1/7 Metheus Series - Wuthering Waves | Kuro Games Figure" ,
      rating: "95",
    },
    {
      index: 9,
      name:  "Midoriya Figure",
      path: Midoriya,
      brand: "Kotobukiya",
      NewPrice: "1.979.000 VND",
      description: "SH Figuarts My Hero Academia Midoriya & Katsuki Bakugo Set" ,
      rating: "76",
    },
    {
      index: 10,
      name:  "Kurumi Figure",
      path: Kurumifi,
      brand: "GENDA GIGO Entertainment",
      NewPrice: "1.380.000 VND",
      description: "Kurumi Tokisaki 1/3 No.024 - Date A Live IV | azone international Doll" ,
      rating: "76",
    }
   
]

export default ListProduct;